module.exports = __webpack_public_path__ + "Montserrat-Bold.f75c7f65536bfef1fa45.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Bold.ttf
// module id = 276
// module chunks = 2